import ResourceTabPanelView from './ResourceTabPanel.view';
export default ResourceTabPanelView;
